<template>
  <tbody class="divide-y divide-xp-line-grey">
  <template v-for='(item, model ) in results'>
    <tr v-for='stock_model_item in results[model]'>
      <td class="whitespace-nowrap px-3 py-1 tracking-wide">
        <img
            class="object-contain object-center w-24 h-24 min-h-24 aspect-square min-w-24"
            :src="stock_model_item.model_image"
            alt=""
        >
      </td>
      <td v-text="model" class="whitespace-nowrap px-3 py-1 pr-16 font-bold tracking-wide text-black lg:text-lg"></td>
      <td v-text="stock_model_item.distributor"
          class="whitespace-nowrap px-3 py-2 tracking-wide text-black font-normal"></td>
      <td v-text="stock_model_item.stock" class="whitespace-nowrap px-3 py-2 tracking-wide text-black font-normal"></td>
      <td class="whitespace-nowrap py-2 pl-3 pr-6 text-right tracking-wide text-black">
        <a v-if="!stock_model_item.stock > 0  && stock_model_item.link != ''"
           class="group inline-flex items-center gap-2 rounded text-black border-2 border-xp-carbon py-1.5 px-3 hover:border-xp-electron-green hover:bg-xp-electron-green"
           :href="stock_model_item.link"
           target="_blank"
        >
          <svg class="text-xp-lilac group-hover:text-black"
               width="19" height="18"
               xmlns="http://www.w3.org/2000/svg">
            <defs>
              <clipPath id="a">
                <path d="M1700 0v1939H0V0h1700Z"/>
              </clipPath>
              <clipPath id="b">
                <path
                    d="M3 11.25a.75.75 0 1 0 0 1.5l.102-.007A.75.75 0 0 0 3.75 12l-.007-.102a.75.75 0 0 0-.641-.641L3 11.25Zm7.5 0-.102.007A.75.75 0 0 0 9.75 12l.007.102a.75.75 0 0 0 .743.648l.102-.007A.75.75 0 0 0 11.25 12l-.007-.102a.75.75 0 0 0-.743-.648Zm1.786-9H2.715l.9 4.5h6.421l2.25-4.5Zm1.885-.415-3 6a.75.75 0 0 1-.671.415H3.31l-1.5 1.5h8.69l.154.005A2.25 2.25 0 0 1 12.75 12l-.005.154A2.25 2.25 0 0 1 10.5 14.25l-.154-.005A2.25 2.25 0 0 1 8.25 12l.005-.154a2.24 2.24 0 0 1 .123-.595H5.122c.083.234.128.486.128.749l-.005.154A2.25 2.25 0 0 1 3 14.25l-.154-.005a2.25 2.25 0 0 1-1.864-3.24C.247 10.518.03 9.409.75 8.689l1.435-1.436L.885.75H0L-.102.743A.75.75 0 0 1 0-.75h1.5l.106.007c.276.04.509.23.601.494l.028.102.18.897H13.5l-.001.453L13.5.75a.75.75 0 0 1 .67 1.085Z"/>
              </clipPath>
            </defs>
            <g clip-path="url(#a)"
               transform="translate(-1400 -642)">
              <g clip-path="url(#b)"
                 transform="translate(1402.75 644.25)">
                <path fill="currentColor"
                      d="M-.75-.75h15v15h-15v-15z"/>
              </g>
            </g>
          </svg>

          <span class="text-sm font-bold uppercase tracking-[2.5px]">
                                                                                Buy it now
                                                                            </span>
        </a>
        <a v-else-if="stock_model_item.link != ''"
           class="group inline-flex items-center gap-2 rounded text-black border-2 border-xp-carbon py-1.5 px-3 hover:border-xp-electron-green hover:bg-xp-electron-green"
           :href="stock_model_item.link"
           target="_blank"
        >
          <svg class="text-xp-lilac group-hover:text-black"
               width="17" height="15" viewBox="0 0 17 15"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.2456 12.5466H14.69C14.69 9.5398 12.2524 7.10224 9.24557 7.10224H3.33278L6.68442 10.4412C6.99997 10.7449 6.99997 11.2374 6.68442 11.5411C6.38059 11.8448 5.88816 11.8448 5.58444 11.5411L0.917814 6.87439C0.613984 6.57068 0.613984 6.07819 0.917814 5.77448L5.58444 1.10779C5.88815 0.804077 6.38058 0.804077 6.68442 1.10779C6.99997 1.41156 6.99997 1.90399 6.68442 2.20777L3.3328 5.54664H9.24558C13.1116 5.54664 16.2456 8.68067 16.2456 12.5466H16.2456ZM16.2456 12.5467V14.1022C16.2456 14.5318 15.8973 14.88 15.4677 14.88C15 14.88 14.69 14.5318 14.69 14.1022V12.5467H16.2456Z"
                fill="currentColor"/>
          </svg>

          <span class="text-sm font-bold uppercase tracking-[2.5px]">
                                                                                Backorder
                                                                            </span>
        </a>
        <div v-else
             class="group inline-flex items-center gap-2 rounded text-xp-medium-grey border-2 border-xp-medium-grey py-1.5 px-3 cursor-not-allowed">
          <svg class="text-xp-medium-grey" width="17"
               height="15" viewBox="0 0 17 15" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.2456 12.5466H14.69C14.69 9.5398 12.2524 7.10224 9.24557 7.10224H3.33278L6.68442 10.4412C6.99997 10.7449 6.99997 11.2374 6.68442 11.5411C6.38059 11.8448 5.88816 11.8448 5.58444 11.5411L0.917814 6.87439C0.613984 6.57068 0.613984 6.07819 0.917814 5.77448L5.58444 1.10779C5.88815 0.804077 6.38058 0.804077 6.68442 1.10779C6.99997 1.41156 6.99997 1.90399 6.68442 2.20777L3.3328 5.54664H9.24558C13.1116 5.54664 16.2456 8.68067 16.2456 12.5466H16.2456ZM16.2456 12.5467V14.1022C16.2456 14.5318 15.8973 14.88 15.4677 14.88C15 14.88 14.69 14.5318 14.69 14.1022V12.5467H16.2456Z"
                fill="currentColor"/>
          </svg>

          <span class="text-sm font-bold uppercase tracking-[2.5px]">
                                                                                Backorder
                                                                            </span>
        </div>
      </td>
    </tr>
  </template>
  </tbody>
</template>

<script>
export default {
  name: 'StockCheckTable',
  props: {
    stock: {
      required: true,
      type: Object,
    },
  },
  watch: {
    stock: function(newVal) {
      this.results = newVal
    }
  },
  data: () => ({
    results: {},
  }),
  mounted() {
    this.results = this.stock
  },
}
</script>